'use client'

import { fetchGetAdsFilters, fetchGetAdsFilterModelByBrand } from "@/services/api";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

export default function HomeSearchSection() {
    const router = useRouter();
    const { handleSubmit, setValue } = useForm();
    const [filters, setFilters] = useState({ isLoading: true, brands: [], models: [], yearsModel: [], transmissions: [], fuels: [] });
    const [filterBrand, setFilterBrand] = useState({ isLoading: false, brand: "" });

    useEffect(() => {
        if (filters.isLoading) {
            fetchGetAdsFilters({ condition: null })
                .then(res => {
                    if (res) { setFilters({ isLoading: false, ...res }); }
                })
                .catch(() => { setFilters({ ...filters, isLoading: false }); });
        }
    }, [filters]);

    const onSubmit = () => {
        const ddlBrand = $('#ddlBrand')[0].value;
        const ddlModel = $('#ddlModel')[0].value;
        const ddlPriceFrom = $('#ddlPriceFrom')[0].value;
        const ddlPriceTo = $('#ddlPriceTo')[0].value;
        let query = {};
        if (ddlBrand) query.marca = ddlBrand; else delete query.marca;
        if (ddlModel) query.modelo = ddlModel; else delete query.modelo;
        if (ddlPriceFrom) query.preco_de = ddlPriceFrom; else delete query.preco_de;
        if (ddlPriceTo) query.preco_ate = ddlPriceTo; else delete query.preco_ate;
        router.push(`/estoque?${new URLSearchParams(query)}`);
    }

    useEffect(() => {
        if (filterBrand.isLoading) {
            fetchGetAdsFilterModelByBrand({ brand: filterBrand.brand })
                .then(res => {
                    if (res) { setFilters(prevFilters => ({ ...prevFilters, isLoading: false, models: res.models })); }
                    setFilterBrand({ ...filterBrand, isLoading: false });
                })
                .catch(() => { setFilterBrand({ ...filterBrand, isLoading: false }); });
        }
        setValue('ddlModel', "");
    }, [filterBrand, filters, setValue]);


    const handleBrandChange = (event) => {
        let idBrand = event.target.value;
        if (idBrand)
            setFilterBrand({ ...filterBrand, isLoading: true, brand: idBrand });
        else setFilters({ ...filters, isLoading: true });
    }

    return (
        <section id="filter_form2">
            <div className="auto-container">
                <div className="search-home">
                    <div className="row">
                        <div className="col-md-12 theme-mb-10">
                            <div className="site-heading text-left">
                                <h2>PESQUISAR VEÍCULOS</h2>
                                <p></p>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix d-block w-100"></div>
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 theme-mb-20">
                                        <div className="form-group">
                                            <i className="mdi mdi-menu"></i>
                                            <select id="ddlBrand" className="nice-select" onChange={handleBrandChange}>
                                                <option value="">Selecione a Marca</option>
                                                {filters.brands.map((item, index) => <option value={item.name} key={index}>{item.name.toUpperCase()}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 theme-mb-20">
                                        <div className="form-group">
                                            <i className="mdi mdi-car"></i>
                                            <select id="ddlModel" className="nice-select">
                                                <option value="">Selecione o Modelo</option>
                                                {filters.models.map((item, index) => <option value={item.name} key={index}>{item.name.toUpperCase()}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 theme-mb-20">
                                        <div className="form-group">
                                            <i className="mdi mdi-cash"></i>
                                            <select id="ddlPriceFrom" className="nice-select">
                                                <option value=''>Valor De</option>
                                                <option value='10000'>R$ 10.000,00</option>
                                                <option value='20000'>R$ 20.000,00</option>
                                                <option value='30000'>R$ 30.000,00</option>
                                                <option value='40000'>R$ 40.000,00</option>
                                                <option value='50000'>R$ 50.000,00</option>
                                                <option value='60000'>R$ 60.000,00</option>
                                                <option value='70000'>R$ 70.000,00</option>
                                                <option value='80000'>R$ 80.000,00</option>
                                                <option value='90000'>R$90.000,00</option>
                                                <option value='100000'>R$ 100.000,00</option>
                                                <option value='200000'>R$ 200.000,00</option>
                                                <option value='300000'>R$ 300.000,00</option>
                                                <option value='400000'>R$ 400.000,00</option>
                                                <option value='500000'>R$ 500.000,00</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 theme-mb-20">
                                        <div className="form-group">
                                            <i className="mdi mdi-cash"></i>
                                            <select id="ddlPriceTo" className="nice-select">
                                                <option value=''>Valor Até</option>
                                                <option value='10000'>R$ 10.000,00</option>
                                                <option value='20000'>R$ 20.000,00</option>
                                                <option value='30000'>R$ 30.000,00</option>
                                                <option value='40000'>R$ 40.000,00</option>
                                                <option value='50000'>R$ 50.000,00</option>
                                                <option value='60000'>R$ 60.000,00</option>
                                                <option value='70000'>R$ 70.000,00</option>
                                                <option value='80000'>R$ 80.000,00</option>
                                                <option value='90000'>R$90.000,00</option>
                                                <option value='100000'>R$ 100.000,00</option>
                                                <option value='200000'>R$ 200.000,00</option>
                                                <option value='300000'>R$ 300.000,00</option>
                                                <option value='400000'>R$ 400.000,00</option>
                                                <option value='500000'>R$ 500.000,00</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                        <button type="submit" name="SendPostFormSearch" value="SendPostFormSearch" className="btn btn-orange btn-arrow theme-mb-10 theme-mr-10 btn-full-mobile">
                                            <span>PESQUISAR <i className="mdi mdi-magnify"></i></span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}